import { StatisticsStats } from "../actions";

const initialState = {
  sessions: { loading: false, period: "all" },
  activeUsers: { loading: false },
  properties: { loading: false },
  communities: { loading: false },
  communitiesList: { loading: false, docs: [], totalPages: 0, hasNextPage: false },
  usersList: { loading: false, docs: [], totalPages: 0, hasNextPage: false },
  propertiesList: { loading: false, docs: [], totalPages: 0, hasNextPage: false },
  subscriptions: { loading: false },
  subscribedUsers: { loading: false },
  freeUsers: { loading: false },
  monthlyUsers: { loading: false },
  annualUsers: { loading: false },
  freeCommunities: { loading: false },
  monthlyCommunities: { loading: false },
  annualCommunities: { loading: false },
  wallets: { loading: false },
  bankAccounts: { loading: false },
  growth: { loading: false },
  appSessions: { loading: false },
  appDownloads: { loading: false },
  appSessions: { loading: false },
  notifications: [],
  totalPages: 0,
  activeUsersList: [],
  mostActiveUsersList: [],
  totalPagesMostActiveUsers: 0,
  receivers: [],
  autoCompleteUsers: [],
  propertiesArray: [],
  propertiesWithCoordinates: [],
  totalPagesProperties: 0,
};

const handleNewNotifications = (state, payload, page) => {
  let newState = { ...state };
  if (page === 1) return payload.docs;
  const _docs = payload.notifications.docs.filter(
    (newDoc) => !state.find((oldDoc) => newDoc._id === oldDoc._id)
  );
  newState = {
    ...payload,
    notifications: [...state.notiications, ..._docs],
  };
  return newState;
};

const handleNewProperites = (state, payload, page) => {
  let newState = { ...state };
  if (page === 1) {
    return payload;
  }
  const _docs = payload.filter(
    (newDoc) =>
      !state.propertiesArray.find((oldDoc) => newDoc._id === oldDoc._id)
  );
  newState = {
    ...payload,
    propertiesArray: [...state.propertiesArray, ..._docs],
  };
  return newState.propertiesArray;
};

const dashboard = (
  state = initialState,
  { type, payload, page, locationsWithCoordinates } = {}
) => {
  switch (type) {
    case StatisticsStats.GET_STATISTICS_SUCCESS:
      if (payload.docs && payload.page && payload.page > 1)
        return {
          ...state,
          [payload.type]: {
            ...(state?.[payload.type] || {}),
            ...payload,
            docs: [...(state?.[payload.type]?.docs || []), ...payload.docs],
          },
        };
      else
        return {
          ...state,
          [payload.type]: { ...(state?.[payload.type] || {}), ...payload },
        };
    case StatisticsStats.GET_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notifications: handleNewNotifications(
          state.notifications,
          payload.notifications,
          payload.notifications.page
        ),
        totalPages: payload.notifications.totalPages,
      };
    case StatisticsStats.GET_PROPERTIES_SUCCESS:
      return {
        ...state,
        propertiesArray: handleNewProperites(state, payload.docs, payload.page),
        propertiesWithCoordinates: locationsWithCoordinates,
        totalPagesProperties: payload.totalPages,
      };
    case StatisticsStats.GET_ACTIVE_USERS_LIST_SUCCESS:
      return {
        ...state,
        activeUsersList: [...payload],
      };
    case StatisticsStats.GET_MOST_ACTIVE_USERS_LIST_SUCCESS:
      return {
        ...state,
        mostActiveUsersList: payload.docs || [],
        totalPagesMostActiveUsers: payload.totalPages || 0,
      };
    case StatisticsStats.GET_RECEIVERS_SUCCESS:
      return {
        ...state,
        receivers: [...payload.receivers.docs],
      };
    case StatisticsStats.USER_AUTOCOMPLETE_SUCCESS:
      return {
        ...state,
        autoCompleteUsers: [...payload],
      };
    case StatisticsStats.GET_COMMUNITIES_LIST:
      return {
        ...state,
        communitiesList: {
          ...state.communitiesList,
          loading: true,
        },
      };
    case StatisticsStats.GET_COMMUNITIES_LIST_SUCCESS:
      return {
        ...state,
        communitiesList: {
          loading: false,
          docs: payload.isFirstPage 
            ? (payload.docs || [])
            : [
                ...(state.communitiesList.docs || []),
                ...(payload.docs || [])
              ],
          totalPages: payload.totalPages || 0,
          hasNextPage: payload.hasNextPage || false,
        },
      };
    case StatisticsStats.GET_COMMUNITIES_LIST_ERROR:
      return {
        ...state,
        communitiesList: {
          ...state.communitiesList,
          loading: false,
        },
      };
    case StatisticsStats.GET_USERS_LIST:
      return {
        ...state,
        usersList: {
          ...state.usersList,
          loading: true,
        },
      };
    case StatisticsStats.GET_USERS_LIST_SUCCESS:
      return {
        ...state,
        usersList: {
          loading: false,
          docs: payload.isFirstPage 
            ? (payload.docs || [])
            : [
                ...(state.usersList.docs || []),
                ...(payload.docs || [])
              ],
          totalPages: payload.totalPages || 0,
          hasNextPage: payload.hasNextPage || false,
        },
      };
    case StatisticsStats.GET_USERS_LIST_ERROR:
      return {
        ...state,
        usersList: {
          ...state.usersList,
          loading: false,
        },
      };
    case StatisticsStats.GET_PROPERTIES_LIST:
      return {
        ...state,
        propertiesList: {
          ...state.propertiesList,
          loading: true,
        },
      };
    case StatisticsStats.GET_PROPERTIES_LIST_SUCCESS:
      // Ensure payload and docs exist and are valid
      const newDocs = Array.isArray(payload.docs) ? payload.docs.filter(Boolean) : [];
      const existingDocs = Array.isArray(state.propertiesList?.docs) ? state.propertiesList.docs : [];
      
      return {
        ...state,
        propertiesList: {
          loading: false,
          docs: payload.isFirstPage 
            ? newDocs
            : [...existingDocs, ...newDocs],
          totalPages: payload.totalPages || 0,
          hasNextPage: payload.hasNextPage || false,
        },
      };
    case StatisticsStats.GET_PROPERTIES_LIST_ERROR:
      return {
        ...state,
        propertiesList: {
          ...state.propertiesList,
          loading: false,
        },
      };
    default:
      return state;
  }
};

export default dashboard;
